module.exports = __webpack_public_path__ + "static/media/Acrilico (26).9117f33c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (26).jpg
// module id = 294
// module chunks = 0